// src/pages/WritePost/index.jsx - 修复版
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useArticles } from '../../contexts/ArticleContext';
import RichTextEditor from '../../components/ArticleEditor/RichTextEditor';
import { Card, message, Result, Button } from 'antd';
import { 
  ArrowLeftOutlined,
  CheckCircleOutlined,
  HomeOutlined
} from '@ant-design/icons';
import './index.css';

function WritePost() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { addArticle } = useArticles();
  
  const [loading, setLoading] = useState(false);
  const [published, setPublished] = useState(false);
  const [newPostId, setNewPostId] = useState(null);

  // 保存文章
  const handleSave = async (articleData) => {
    setLoading(true);
    try {
      const newArticle = {
        ...articleData,
        author: user?.username || '匿名作者',
        authorId: user?.id || Date.now(),
        authorAvatar: user?.avatar || '',
        createdAt: new Date().toISOString(),
        views: 0,
        likes: 0,
        comments: 0
      };

      const savedArticle = addArticle(newArticle);
      setNewPostId(savedArticle.id);
      setPublished(true);
      
      message.success('文章发布成功！');
      
    } catch (error) {
      console.error('发布文章失败:', error);
      message.error('发布失败');
    } finally {
      setLoading(false);
    }
  };

  // 取消编辑
  const handleCancel = () => {
    navigate('/archive');
  };

  // 查看新文章
  const viewNewPost = () => {
    if (newPostId) {
      navigate(`/article/${newPostId}`);
    }
  };

  // 继续写作
  const continueWriting = () => {
    setPublished(false);
    setNewPostId(null);
  };

  // 成功发布页面
  if (published) {
    return (
      <div className="write-post">
        <div className="container">
          <Result
            icon={<CheckCircleOutlined style={{ color: '#52c41a', fontSize: 64 }} />}
            title="文章发布成功！"
            subTitle="您的文章已经成功发布到博客中。"
            extra={[
              <Button 
                key="view" 
                type="primary"
                onClick={viewNewPost}
                size="large"
              >
                查看文章
              </Button>,
              <Button 
                key="continue" 
                onClick={continueWriting}
                size="large"
              >
                继续写作
              </Button>,
              <Button 
                key="home" 
                onClick={() => navigate('/')}
                icon={<HomeOutlined />}
                size="large"
              >
                返回首页
              </Button>
            ]}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="write-post">
      <div className="container">
        <div className="write-header">
          <div className="header-content">
            <Button 
              onClick={handleCancel}
              icon={<ArrowLeftOutlined />}
              className="back-btn"
            >
              返回
            </Button>
            <div className="header-text">
              <h1>写新文章</h1>
              <p className="subtitle">分享你的思想和创意</p>
            </div>
          </div>
        </div>

        <Card className="editor-card">
          <RichTextEditor
            initialData={{}}
            onSave={handleSave}
            onCancel={handleCancel}
            mode="create"
            loading={loading}
          />
        </Card>

        {/* 写作提示 */}
        <Card className="writing-tips" size="small">
          <h3>📝 写作提示</h3>
          <ul>
            <li>使用清晰的标题和摘要，吸引读者</li>
            <li>合理使用分类和标签，方便查找</li>
            <li>发布前预览文章，检查格式和内容</li>
            <li>尊重原创，转载请注明出处</li>
          </ul>
        </Card>
      </div>
    </div>
  );
}

export default WritePost;